import { theme } from 'src/presentation/styles/styles'

export class MobileHelper {
  static lowResolution(): boolean {
    return window.innerWidth < parseInt(theme.breakpoints[2], 10)
  }
}
